import { type ComponentProps } from 'react'

import Svg from '~/shared/assets/Svg'

interface Props extends ComponentProps<typeof Svg> {}

const ImageUpload = ({ color = '#313634', ...rest }: Props) => {
  return (
    <Svg
      width={36}
      height={37}
      viewBox="0 0 36 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M7.5 32C6.675 32 5.96875 31.7062 5.38125 31.1187C4.79375 30.5312 4.5 29.825 4.5 29V8C4.5 7.175 4.79375 6.46875 5.38125 5.88125C5.96875 5.29375 6.675 5 7.5 5H21V8H7.5V29H28.5V15.5H31.5V29C31.5 29.825 31.2062 30.5312 30.6187 31.1187C30.0312 31.7062 29.325 32 28.5 32H7.5ZM25.5 14V11H22.5V8H25.5V5H28.5V8H31.5V11H28.5V14H25.5ZM9 26H27L21.375 18.5L16.875 24.5L13.5 20L9 26Z"
        fill={color}
      />
    </Svg>
  )
}

export default ImageUpload
